import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import vi from './vi.json'
import en from './en.json'
import la from './la.json'
import cn from './cn.json'

const resources = {
   vi: {
      translation: vi
   },
   en: {
      translation: en
   },
   la: {
      translation: la // Thêm nếu bạn có file la.json
   },
   cn: {
      translation: cn // Thêm nếu bạn có file cn.json
   }
}

i18n
   .use(initReactI18next) // Kết nối i18next với React
   .init({
      resources,
      lng: 'vi', // Ngôn ngữ mặc định
      fallbackLng: 'en', // Ngôn ngữ dự phòng nếu không tìm thấy bản dịch
      interpolation: {
         escapeValue: false // Không escape HTML trong chuỗi dịch
      }
   })
export default i18n
